import {JetView, plugins} from "webix-jet"; // Importing JetView and plugins from webix-jet framework
import {devConfig} from "config/config"; // Importing development configuration settings

/**
 * UsersVerificationView class extends JetView to create a user verification interface.
 */
export default class UsersVerificationView extends JetView {
	/**
	 * Configures the layout of the view.
	 * @returns {Object} The configuration object for the view.
	 */
	config(){
		const _ = this.app.getService("locale")._; // Localization service for internationalization
		const theme = this.app.config.theme; // Current theme configuration
		return {
			type: "clean", // Clean layout type
			view:"form", // Form view
			id:"a10", // Unique identifier for the form
			scroll: "y", // Enable vertical scrolling
            rows:[{
            	type:"wide", // Wide layout type
                responsive: "a10", // Responsive design based on the identifier
                margin: 10, // Margin around the rows
					cols:[
						{
							localId:"inner:layout", gravity:4, type: "wide", rows:[
								{
										view: "toolbar", css: theme, // Toolbar with the current theme
										elements: [
												{width: 30, css:"back-button", view:"button", type:"icon", icon:"wxi-angle-left", id:"security.adminuser", align:"center",
												click:()=> { // Click event to navigate to another view
														this.show("../usersVerification2");
												}},
												{hidden: !devConfig.getPermAction('viewEmailUserVerification', 'Add'), // Conditional visibility based on permissions
													css:"user-selected", 
													view: "label", 
													id:"lblTittle", // Unique identifier for the label
													align:"center" 
											 	}
										]
								},
								{ $subview:true } // Placeholder for subview
							]
						}
					]
					}]
		};
	}

	/**
	 * Initializes the view and sets up event listeners.
	 */
	init(){
		this.on(this.app,"person:select",person => this.setParam("user",person.id,true)); // Event listener for user selection
		const cur_user = this.getParam("user", true); // Retrieve the current user parameter
		const _ = this.app.getService("locale")._; // Localization service for internationalization
		webix.ajax().get(devConfig.geturlApi() + "es/Client/GetClientById", 'id=' + cur_user, { // AJAX request to get client data by ID
			error: function (text, data, XmlHttpRequest) { // Error handling for the AJAX request
				webix.message("Error! "); // Display error message
			},
			success: function (text, data, XmlHttpRequest) { // Success handling for the AJAX request
				data = JSON.parse(text); // Parse the response data
			}
		});
	}
}

// FILE DOCUMENTED
